import common from '../common';
import Scene from './Scene';
import MenuPanel from '../ui/MenuPanel';
import PalettePanel from '../ui/PalettePanel';
import MyGame from '../game/MyGame';
import Tutorial from '../game/Tutorial';
import commonGame from '../commonGame';

const _createBackground = Symbol('_createBackground');
const _createButtons = Symbol('_createButtons');
const _onMenuBtn_Click = Symbol('_onMenuBtn_Click');
const _onPaletteBtn_Click = Symbol('_onPaletteBtn_Click');

export default class GameScene extends Scene {
	constructor() {
		super();

		// Attributes.
		this._menuPanel = null;
		this._tutorial = null;

		this._gameLayer = null;
		this._tutorialLayer = null;
		this._overlayLayer = null;

		this._menuPanel = null;
		this._palettePanel = null;

		this.allStamps = [];
	}

	init() {
		super.init();
		this[_createBackground]();

		// Layers.
		this._gameLayer = new PIXI.Container();
		this.addChild(this._gameLayer);
		this._tutorialLayer = new PIXI.Container();
		this.addChild(this._tutorialLayer);
		this._overlayLayer = new PIXI.Container();
		this.addChild(this._overlayLayer);

		// Overlay initialization. Order is important due to dependencies.
		// Menu.
		this._menuPanel = new MenuPanel(this.signals);
		this._menuPanel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._menuPanel.init();
		this._overlayLayer.addChild(this._menuPanel);

		// Palette.
		this._palettePanel = new PalettePanel();
		this._palettePanel.position = new PIXI.Point(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		this._palettePanel.init();
		this._overlayLayer.addChild(this._palettePanel);

		// Game.
		common.game = new MyGame();
		common.game.scene = this;
		common.game.init();

		common.gameScene = this;

		// Tutorial.
		if (common.savedData.isDrawTutorial || common.savedData.isToolTutorial || common.savedData.isPaletteTutorial) {
			this._tutorial = new Tutorial();
			this._tutorial.init();
			this._tutorial.signals.onCompleted.once(
				function() {
					this._tutorial.end();
					this._tutorial.destroy();
					this._tutorial = null;
				},
				this);
			this._tutorialLayer.addChild(this._tutorial);
		}

		// Signals.
		// Link the panels to the HUD buttons that show them.
		common.game.hud.signals.onMenuClick.add(this[_onMenuBtn_Click], this);
		common.game.hud.signals.onPaletteClick.add(this[_onPaletteBtn_Click], this);
	}

	destroy() {
		common.game.destroy();
		this._menuPanel.destroy();
		this._palettePanel.destroy();
		this._tutorial && this._tutorial.destroy();
		// clean up goes here
		super.destroy();
	}

	resize() {
		super.resize();

		common.game.resize();
		if (this._tutorial) this._tutorial.resize();
	}

	appear() {
		this.animateIn();
	}

	animateIn() {
		P3.audio.stopMusic();
		const audios = [
			'music_drawing_loop_00'
		];
		let params = {};
		params.callback = function() {
			P3.audio.playMusic(P3.utils.selectRandom(audios));
		};
		params.scope = this;
		P3.audio.playSound('music_level_play_sting', params);

		common.game.animateIn();
	}

	update() {
		if (this._tutorial) this._tutorial.update();
		common.game.update();
		this._menuPanel.update();
		this._palettePanel.update();
	}

	addTutorialEvent(tutorialEvent) {
		if (this._tutorial) this._tutorial.addEvent(tutorialEvent);
	}

	[_createBackground]() {
		const bgConfig = common.levelConfig.game_scene.bg;

		for (const bgConfigElement of bgConfig)
			this.addChild(common.createSprite(bgConfigElement));
	}

	[_createButtons]() {

	}

	[_onMenuBtn_Click]() {
		this._menuPanel.show();
	}

	[_onPaletteBtn_Click](toolType) {
		// Show palette panel.
		this._palettePanel.show(toolType);

		// Tutorial.
		common.game.scene.addTutorialEvent(commonGame.TUT_EVENT.PALETTE_SELECTED);
	}

	get gameLayer() {
		return this._gameLayer;
	}

	get palettePanel() {
		return this._palettePanel;
	}
}
